#import '../fragment/role.graphql'

query roles($userType: UserTypeEnum) {
  roles(userType: $userType) {
    ...roleFragment
  }
}
